import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid, makeStyles,
  MenuItem,
  TextField, Typography
} from "@material-ui/core";
import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { ReactHookFormSelect } from "../../../utils";

const useStyles = makeStyles(() => ({
  formControl: {
    minWidth: "100%",
  },
}));

export default function FormOnCategory(props) {
  const classes = useStyles();
  const { open, handleClose, option, fetchAPI } = props;
  const { register, handleSubmit, errors, control, clearErrors } = useForm();

  const [addChange, setAddChange] = useState({
    idlayanan: "",
  });
  const { idlayanan } = addChange;

  const reset = () => {
    setAddChange({
      ...addChange,
      idlayanan: "",
    });
    clearErrors()
  }

  const onSubmit = async (item) => {
    const data = ({
      ...item,
      idlayanan: idlayanan,
    })

    const result = await fetchAPI("add", data);
    if (result.status === "success") {
      reset();
    }
    return result
  };

  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="form-dialog-title"
      >
        <form onSubmit={handleSubmit(onSubmit)}>
          <DialogTitle id="form-dialog-title">Add On Category</DialogTitle>
          <DialogContent>
            <Grid container spacing={3}>
              <Grid item xs={12} sm={12}>
                <ReactHookFormSelect
                  id="idlayanan"
                  name="idlayanan"
                  className={classes.textField}
                  label="ID Layanan"
                  control={control}
                  error={errors.idlayanan}
                  value={idlayanan}
                  // handleOption={handleOption}
                  // rules={{
                  //   required: {
                  //     value: true,
                  //     message: `ID layanan tidak boleh kosong`,
                  //   },
                  // }}
                  setState={setAddChange}
                  state={addChange}
                  variant="outlined"
                  margin="normal"
                  fullWidth
                  required
                >
                  <MenuItem value="none" disabled selected>
                    --Pilih Layanan--
                  </MenuItem>
                  {option &&
                    option.map((item, i) => (
                      <MenuItem key={i} value={item.id}>
                        {item.nama}
                      </MenuItem>
                    ))}
                </ReactHookFormSelect>
                {errors.idlayanan && (
                  <Typography variant="caption" color="error">
                    {errors.idlayanan.message}
                  </Typography>
                )}
              </Grid>

              <Grid item xs={12} sm={12}>
                <TextField
                  id="nama"
                  name="nama"
                  label="Name Category "
                  error={errors.nama}
                  fullWidth
                  placeholder="Type your Name Category"
                  variant="outlined"
                  type="string"
                  inputRef={register({
                    required: {
                      value: true,
                      message: "Nama Category tidak boleh kosong",
                    },
                    minLength: {
                      value: 4,
                      message: " must be at least 4 alphas",
                    },
                  })}
                  InputLabelProps={{ shrink: true }}
                  helperText={errors.nama && errors.nama.message}
                />
              </Grid>

              <Grid item xs={12} sm={12}>
                <TextField
                  id="sla"
                  name="sla"
                  label="SLA Per Minutes"
                  placeholder="Type your SLA Per Minutes"
                  type="number"
                  error={errors.sla}
                  fullWidth
                  variant="outlined"
                  inputRef={register({
                    required: {
                      value: true,
                      message: "sla tidak boleh kosong",
                    },
                  })}
                  InputLabelProps={{ shrink: true }}
                  helperText={
                    errors.sla && errors.sla.message
                  }
                />
              </Grid>

              <Grid item xs={12} sm={12}>
                <TextField
                  id="deskripsi"
                  name="deskripsi"
                  label="Description"
                  placeholder="Type your Description"
                  type="string"
                  error={errors.deskripsi}
                  fullWidth
                  variant="outlined"
                  inputRef={register({
                    required: {
                      value: true,
                      message: "Deskripsi tidak boleh kosong",
                    },
                    minLength: {
                      value: 4,
                      message: " must be at least 4 alphas",
                    },
                  })}
                  InputLabelProps={{ shrink: true }}
                  helperText={
                    errors.deskripsi && errors.deskripsi.message
                  }
                />
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button type="submit" color="primary">
              Add
            </Button>
            <Button onClick={handleClose} color="secondary">
              Cancel
            </Button>
          </DialogActions>
        </form>
      </Dialog>
    </div>
  );
}
